import { loadSingleTaskFunctionality } from "../../Utils/Tasks/loadSingleTask";
import { TestEditor } from "./TestEditor";


export function loadTestEditor(){
    new TestEditor();

    loadSingleTaskFunctionality()
}